@if (showModal()) {
  <div
      class="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[1500] p-4"
      (click)="closeOnOverlayClick($event)"
      role="dialog"
      aria-modal="true"
      aria-labelledby="error-modal-title"
      (keydown.escape)="closeModal()">
    <div
        class="bg-dark-gray rounded-2xl border border-white/10 shadow-glow max-w-md w-full animate-appear overflow-hidden"
        #modalContent
        tabindex="-1">
      <div class="flex items-center gap-3 p-5 border-b border-white/10 bg-dark-blue/30">
        <div class="text-electric-blue flex-shrink-0" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               class="w-6 h-6" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <h2 id="error-modal-title" class="text-xl text-white font-bold">Attention Required</h2>
        <button
            (click)="closeModal()"
            class="ml-auto w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 text-white/70 hover:text-white transition-colors"
            aria-label="Close dialog">
          &times;
        </button>
      </div>

      <div class="p-5 max-h-[50vh] overflow-y-auto text-white/80">
        @if (hasMultilineMessage()) {
          <!-- Handle special formatting for file size errors -->
          @if (isFileSizeError()) {
            <p class="mb-3">{{ getErrorIntro() }}</p>

            <!-- Error items list -->
            <div class="space-y-2">
              @for (item of getErrorItems(); track $index) {
                <p class="border-l-2 border-electric-blue/50 pl-3 py-1 bg-dark-blue/30 rounded-r-md text-sm">{{ item }}</p>
              }
            </div>

            <!-- Size limits note -->
            @if (getSizeLimits()) {
              <p class="mt-4 pt-3 border-t border-white/10 text-electric-blue text-sm">{{ getSizeLimits() }}</p>
            }
          } @else {
            <!-- Standard multiline handling -->
            <div class="space-y-2">
              @for (line of getMessageLines(); track $index) {
                <p>{{ line }}</p>
              }
            </div>
          }
        } @else {
          <!-- Simple single-line message -->
          <p>{{ errorData()?.message }}</p>
        }
      </div>

      <div class="p-5 border-t border-white/10 bg-dark-blue/20 flex justify-center">
        <button
          #primaryButton
          (click)="closeModal()"
          class="btn btn-primary py-2 px-6 text-white bg-gradient-to-r from-electric-blue to-electric-blue/80 hover:shadow-glow-sm hover:-translate-y-0.5 transition-all rounded-lg"
          autofocus>Got it
        </button>
      </div>
    </div>
  </div>
}
